
import Vue, { PropType } from "vue";
import { WorkingHourDayViewModel } from "@/presentation/viewmodels/WorkingHourDayViewModel";

export default Vue.extend({
  name: "ProfessionalWorkingHours",
  props: {
    // Já vem agrupado por dia e formatado pelo controller da tela — este
    // componente é só apresentação.
    workingHours: {
      type: Array as PropType<WorkingHourDayViewModel[]>,
      required: true,
    },
  },
});
